var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgSearchResultsMirror1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 388,
    height: 841,
    viewBox: "0 0 388 841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-BG_type1_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 841
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BG_type1_3",
    "data-name": "BG_type1 \\u2013 3",
    clipPath: "url(#clip-BG_type1_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 841,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(-254 -173)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 388,
    height: 841,
    transform: "translate(254 173)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 126.5,
    cy: 126.5,
    r: 126.5,
    transform: "translate(484)",
    fill: "#0000af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M166.776,14.117Q157.854,1.822,147.8.162T118.774,14.117q-7.8,8.922-20.652,21.21Q85.3,47.6,71.331,62.676,57.386,77.748,41.748,94.492q-15.619,16.746-30.141,33.49A39.384,39.384,0,0,0,.443,149.191q-2.22,12.271,6.7,24.56L94.216,311.058q6.694,10.048,11.721,12.837c3.348,1.849,6.33,2.234,8.93,1.118a27.962,27.962,0,0,0,8.372-6.14,85.092,85.092,0,0,1,8.931-7.815L260.547,206.124q8.947-8.946,3.349-22.884a184.42,184.42,0,0,0-14.512-28.466q-21.193-39.09-41.3-75.353a616.972,616.972,0,0,0-41.3-65.3",
    transform: "translate(571.5 288.063)",
    fill: "#fde047"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 225,
    cy: 225,
    r: 225,
    transform: "translate(0 408)",
    fill: "#0000af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M95.168,8.056Q90.077,1.039,84.339.092T67.776,8.056q-4.45,5.091-11.785,12.1-7.315,7-15.288,15.606-7.958,8.6-16.881,18.155T6.624,73.03a22.474,22.474,0,0,0-6.371,12.1q-1.267,7,3.823,14.015L53.763,177.5q3.82,5.734,6.688,7.325c1.91,1.055,3.612,1.275,5.1.638a15.956,15.956,0,0,0,4.777-3.5,48.558,48.558,0,0,1,5.1-4.459l73.256-59.879q5.106-5.1,1.911-13.058a105.234,105.234,0,0,0-8.281-16.244q-12.094-22.306-23.569-43A352.063,352.063,0,0,0,95.168,8.056",
    transform: "translate(158.091 181.272)",
    fill: "#ff1335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M95.168,8.056Q90.077,1.039,84.339.092T67.776,8.056q-4.45,5.091-11.785,12.1-7.315,7-15.288,15.606-7.958,8.6-16.881,18.155T6.624,73.03a22.474,22.474,0,0,0-6.371,12.1q-1.267,7,3.823,14.015L53.763,177.5q3.82,5.734,6.688,7.325c1.91,1.055,3.612,1.275,5.1.638a15.956,15.956,0,0,0,4.777-3.5,48.558,48.558,0,0,1,5.1-4.459l73.256-59.879q5.106-5.1,1.911-13.058a105.234,105.234,0,0,0-8.281-16.244q-12.094-22.306-23.569-43A352.063,352.063,0,0,0,95.168,8.056",
    transform: "translate(553.091 743.272)",
    fill: "#ff1335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M-9433.168,576.667c-2.666-124.667-89.333-264-107.333-287.333-16.658-21.1-37.391-58.451-47.167-92.667-16-56-35.166-225-156.833-311.333",
    transform: "translate(10092.501 216)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M-9694.688,770.333c506-132,295.722-470.22,286.216-485.848a785.174,785.174,0,0,1-39.383-74.152c-30-64-22.833-229.333-211.5-319.667",
    transform: "translate(9932.688 221)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M-9649.659,719.167c442-132.667,281.524-424.217,278.429-429.7-35.817-63.406-56.428-111.971-82.762-186.971s-51.667-160.667-233.667-240.333",
    transform: "translate(9877.659 236.833)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M-9635.333,445.333s-117.138-169.213-121.591-176.465c-11.133-18.128-31.576-54.562-31.576-77.368,0-31.5,10.5-67.5,46-87s92.5-26.5,153-79",
    transform: "translate(10318 214)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M-9510.5,27.5c-40,22.5-89,48-134.5,46.5s-78-44.5-107-162",
    transform: "translate(10202.5 214)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M-9449.781,589c236-51,122.5-282.411,120.59-288.712-31.637-104.42-88.033-146.667-226.34-146.038",
    transform: "translate(9795.781 214)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M-9410.531,130c45.333.667,202.666,40,143.333-71.333S-9422.531-72.667-9422.531-72.667",
    transform: "translate(9616.531 214)",
    fill: "none",
    stroke: "#0000af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(386 396)",
    fill: "#6ee7b7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 72,
    cy: 72,
    r: 72,
    transform: "translate(348 956)",
    fill: "#6ee7b7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(463 381)",
    fill: "#ff1335"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(377 391)",
    fill: "#ff1335"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(434 376)",
    fill: "#1c1cff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(529 422)",
    fill: "#1c1cff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(498 402)",
    fill: "#1c1cff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(466 391)",
    fill: "#1c1cff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(297 347)",
    fill: "#fde047"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(287 347)",
    fill: "#1c1cff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(496 392)",
    fill: "#6ee7b7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(527 411)",
    fill: "#fde047"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    cx: 225,
    cy: 225,
    r: 225,
    transform: "translate(429 829)",
    fill: "#0000af"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSearchResultsMirror1);
export default __webpack_public_path__ + "static/media/bg_search_results_mirror1.052e9c691f62e856b09f5dc0139b56f6.svg";
export { ForwardRef as ReactComponent };